import { ActivityContent } from "@Components/game/activity";
import { BybBackground } from "@Components/game/common";
import ContainerWrapper from "@Components/generic/container-wrapper";
import { ActivityProvider } from "@Context/game/activity/activity-context";
import { Container } from "@mui/material";

const PAGE_ID = "ACTIVITY";
const ACTIVITY_BACKGROUND_IMAGE = "https://challenge-thumbs.b-cdn.net/byb-backgrounds/activity_bg.png?width=1440&height=720";

const Activity = () => {
  return (
    <ActivityProvider>
      <ContainerWrapper id={PAGE_ID} fullHeight>
        <BybBackground imageUrl={ACTIVITY_BACKGROUND_IMAGE} />

        <Container maxWidth="xl">
          <ActivityContent />
        </Container>
      </ContainerWrapper>
    </ActivityProvider>
  );
};

export default Activity;
